import { countryCodes } from '../data/countryCodes';

const SORTED_COUNTRY_CODES = [...countryCodes]
  .map((country) => country.code)
  .sort((a, b) => b.length - a.length);

export const DEFAULT_PHONE_COUNTRY_CODE = '+351';

export const splitPhoneValue = (rawValue, defaultCountryCode = DEFAULT_PHONE_COUNTRY_CODE) => {
  const raw = (rawValue == null ? '' : String(rawValue)).trim();
  if (!raw) {
    return { countryCode: defaultCountryCode, number: '' };
  }

  const compact = raw.replace(/[^\d+]/g, '');
  const normalized = compact.startsWith('+') ? compact : `+${compact}`;

  const matchedCode = SORTED_COUNTRY_CODES.find((code) => normalized.startsWith(code));
  if (matchedCode) {
    return {
      countryCode: matchedCode,
      number: normalized.slice(matchedCode.length),
    };
  }

  return {
    countryCode: defaultCountryCode,
    number: raw.replace(/[^\d]/g, ''),
  };
};

/**
 * Detect browser autofill / paste of a full or national phone into either sub-field.
 * Returns null when the value should be treated as normal country-code search or digit typing.
 */
export const resolvePhoneInputValue = (rawValue, currentCountryCode = DEFAULT_PHONE_COUNTRY_CODE) => {
  const raw = (rawValue == null ? '' : String(rawValue)).trim();
  if (!raw) {
    return null;
  }

  const digits = raw.replace(/\D/g, '');
  const looksInternational = raw.includes('+') || /^\s*00\d/.test(raw);

  if (looksInternational) {
    if (digits.length < 8) {
      return null;
    }

    const split = splitPhoneValue(raw, currentCountryCode);
    const nationalDigits = split.number.replace(/\D/g, '');
    if (nationalDigits.length < 6) {
      return null;
    }

    return split;
  }

  // Autofill often dumps the national number into the country-code field.
  if (digits.length >= 8) {
    return {
      countryCode: currentCountryCode || DEFAULT_PHONE_COUNTRY_CODE,
      number: digits,
    };
  }

  return null;
};

export const composePhoneValue = (countryCode, number) => {
  const code = (countryCode || '').trim();
  const digits = (number || '').trim();
  if (!digits) return '';
  return `${code}${digits}`;
};

export const toPhoneDto = (countryCode, number) => {
  const trimmedNumber = (number || '').trim();
  if (!trimmedNumber) return null;

  return {
    countryCode: (countryCode || DEFAULT_PHONE_COUNTRY_CODE).trim(),
    number: trimmedNumber,
  };
};

export const normalizeFormPhoneFields = (data) => {
  if (!data || typeof data !== 'object') return data;

  const next = { ...data };
  if (next.phone != null && next.phoneNumber == null) {
    const split = splitPhoneValue(next.phone);
    next.phoneCountryCode = split.countryCode;
    next.phoneNumber = split.number;
  }

  if (!next.phoneCountryCode) {
    next.phoneCountryCode = DEFAULT_PHONE_COUNTRY_CODE;
  }
  if (next.phoneNumber == null) {
    next.phoneNumber = '';
  }

  delete next.phone;
  return next;
};
